import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import logo from "../../assets/albertine-icon.svg";
import type { Agent } from "../../common/types/Agent";
import MenuLinks from "./MenuLinks";
import "./MobileMenu.css";
import ProfileDropdown from "./ProfileDropdown";

type Props = {
    currentAgent: Agent;
};

const MobileMenu = function MenuMobile(props: Props) {
    const { currentAgent } = props;
    const [opened, setOpened] = useState(false);
    const history = useHistory();
    const closeMenu = () => {
        setOpened(false);
    };
    useEffect(
        () =>
            history.listen(() => {
                closeMenu();
            }),
        [history],
    );

    return (
        <div className="mobile-menu">
            <div className="mobile-menu__header">
                {/* @ts-ignore we are using outdated libraries that use ReactNode instead of JSX.Element. */}
                <Link to="/" className="mobile-menu__title">
                    <img src={logo} className="mobile-menu__logo" alt="Albertine" />
                </Link>
                <div
                    onClick={() => {
                        setOpened(true);
                    }}
                >
                    Menu
                </div>
            </div>

            {opened && (
                <div className="mobile-menu__overlay">
                    <div className="mobile-menu__header">
                        {/* @ts-ignore we are using outdated libraries that use ReactNode instead of JSX.Element. */}
                        <Link to="/" className="mobile-menu__title">
                            <img
                                src={logo}
                                className="mobile-menu__logo"
                                alt="Albertine"
                            />
                        </Link>
                        <div
                            onClick={() => {
                                setOpened(false);
                            }}
                        >
                            Close
                        </div>
                    </div>
                    <div className="mobile-menu__body">
                        <div className="mobile-menu__scroll">
                            <MenuLinks currentAgent={currentAgent} />
                        </div>
                        <ProfileDropdown currentAgent={currentAgent} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default MobileMenu;
